import React from "react";
import { Modal, Button, Table, Form } from "react-bootstrap";
import CancelButton from "presentation/components/buttons/cancel";
import moment from "moment";

import 'react-calendar/dist/Calendar.css';
import Calendar from 'react-calendar';

import { goTo, handleResultData } from "presentation/utils/functions/generic";

import courseDisciplinesService from "presentation/services/course-disciplines";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";
import timesheetsService from "presentation/services/timesheets";

class SelectDisciplineAttendanceModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            form: { disciplineId: -9999 },
            selectedItem: null,
            disciplines: [],
            academicPeriodDates: [],
            validDates: [],
            data: []
        };

        this.tBodyRef = React.createRef(null);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = async () => {
        const { academicPeriodId, courseId } = this.props;
        this.setState({ loading: true });

        let disciplines = [];
        await courseDisciplinesService.search({ courseId: [parseInt(courseId)], academicPeriodId: [parseInt(academicPeriodId)] }).then((result) => {
            disciplines = handleResultData(result);
        });


        this.setState({ loading: false, disciplines: disciplines });
    }

    loadDates = async (classroomId, disciplineId, academicPeriodId) => {
        let academicPeriodDates = [];
        let validDates = [];

        await timesheetsService.getSchoolDays(classroomId, disciplineId, academicPeriodId).then((result) => {
            let handledResult = handleResultData(result);
            if (!handledResult.error) {
                academicPeriodDates = handledResult;
                validDates = handledResult.map(x => { return moment(x.startDate).format("YYYY-MM-DD") });

            }
        });

        return { validDates: validDates, academicPeriodDates: academicPeriodDates };
    }


    dateIsDisabled = (dateInformation) => {
        const { validDates } = this.state;
        let checkDate = moment(dateInformation.date).format("YYYY-MM-DD");
        return !validDates.includes(checkDate);
    }

    handleChangeDate = (value, event) => {
        const { academicPeriodDates } = this.state;

        let existing = academicPeriodDates.filter(x => moment(x.startDate).format("YYYY-MM-DD") == moment(value).format("YYYY-MM-DD"))[0];
        this.setState({ selectedItem: existing.id });
    }

    handleChangeDiscipline = async (event) => {
        const { loadDates } = this;
        const { academicPeriodId, classroomId } = this.props;
        const { form } = this.state;
        let disciplineId = event.target.value;
        this.setState({ loading: true });

        let dateInfo = await loadDates(classroomId, disciplineId, academicPeriodId);

        let { academicPeriodDates, validDates } = dateInfo;

        this.setState({ form: { ...form, disciplineId: disciplineId }, validDates: validDates, academicPeriodDates: academicPeriodDates, loading: false });
    }


    onSubmit = async () => {

        let { classroomId, component } = this.props;
        let { selectedItem, form } = this.state;

        this.setState({ loading: true, error: '' });
        console.log(this.state);
        let hasInvalidInfo = !selectedItem || !form.disciplineId;

        if (hasInvalidInfo) {
            this.setState({ loading: false, error: true, message: (!selectedItem ? "Por favor, selecione uma data..." : "Por favor, selecione uma disciplina") });
        } else {
            let targetUrl = `/turmas/${classroomId}/frequencia-por-aula/${selectedItem}/${form.disciplineId}`;
            goTo(targetUrl, component);
        }
    };

    render() {
        let { show, onClose, classroomName } = this.props;
        let { loading, selectedItem, disciplineId, error, message, validDates, form, disciplines } = this.state;
        const { onSubmit, dateIsDisabled, handleChangeDate, handleChangeDiscipline } = this;
        const hasSelection = !(selectedItem == null) || !(disciplineId == null);
        return (
            <Modal size="lg" backdrop="static" show={show || false} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{classroomName} / Registro de Frequência por aula</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading === true && <PageLoadingIndicator loadingText={"Carregando informações..."} />}
                    {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
                    {loading === false && (
                        <>
                            <div className="form mt-2">
                                <Form.Label htmlFor="disciplineId">Disciplina</Form.Label>
                                <Form.Select
                                    aria-label="Disciplina"
                                    id="disciplineId"
                                    name="disciplineId"
                                    defaultValue={form.disciplineId}
                                    onChange={async (e) => await handleChangeDiscipline(e)}
                                    aria-describedby="disciplineIdHelpBlock"
                                    required
                                >
                                    <option value={-9999}>Selecione uma disciplina</option>
                                    {disciplines.map((e, i) => { return <option key={e.disciplineId} value={e.disciplineId}>{e.discipline.displayName}</option> })}
                                </Form.Select>
                                <Form.Text id="disciplineIdHelpBlock" muted>
                                    Escolha uma disciplina para realizar o lançamento de frequência
                                </Form.Text>
                            </div>
                            <div className="react-calendar-container">
                                {validDates.length > 0 && form.disciplineId >= 0 && <Calendar
                                    locale="pt-BR"
                                    tileDisabled={dateIsDisabled}
                                    onChange={(value, event) => handleChangeDate(value, event)}
                                />}
                                {validDates.length <= 0 && form.disciplineId >= 0 && <p><strong>Não encontrei dias letivos para essa disciplina. Por favor, verifique o quadro de horários dessa turma.</strong></p>}
                            </div>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <CancelButton
                        containerProps={{
                            disabled: loading,
                            onClick: onClose
                        }}
                    />
                    <Button disabled={loading || !hasSelection} variant="success" onClick={() => onSubmit()}>
                        Iniciar
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };
}

export default SelectDisciplineAttendanceModal;